export default "__VITE_ASSET__CzsOAwoW__"